// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__2YwRv","landing-left":"Landing_landing-left__pbxAh","landing-right":"Landing_landing-right__OZHRQ","right-container":"Landing_right-container__2si9z"};